import { render, staticRenderFns } from "./SalesPersonListView.vue?vue&type=template&id=45b734f4"
import script from "./SalesPersonListView.vue?vue&type=script&lang=js"
export * from "./SalesPersonListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports